<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="4" class="px-0">
        <CommsGroupListing
          @selected="handleSelectedGroup"
          @show-members="handleShowMembers"
          :show-members-group="showMembersGroup"
        ></CommsGroupListing>
      </v-col>
      <v-col cols="8">
        <CommsGroupDetails
          :group="group"
          :show-members-group="showMembersGroup"
        ></CommsGroupDetails>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_PREFIX_COMMUNICATION } from "@/store";
import { SAVE_SHOW_MEMBERS_ON_MAP } from "@/store/actions.type";
import MASS_COMM_CONSTANTS from "../../common/constants/massComm/massComm.js";
export default {
  name: "CommsGroups",
  components: {
    CommsGroupListing: () =>
      import("@/components/communication/CommsGroupListing"),
    CommsGroupDetails: () =>
      import("@/components/communication/CommsGroupDetails"),
  },
  props: {},
  data: () => ({
    group: null,
    showMembersGroup: null,
  }),
  async mounted() {
    if (this.showMembersOnMap.type === MASS_COMM_CONSTANTS.GROUP_TYPE) {
      this.handleShowMembers(this.showMembersOnMap.data);
    }
  },
  computed: {
    ...mapGetters({
      showMembersOnMap: MODULE_PREFIX_COMMUNICATION + "showMembersOnMap",
    }),
  },
  methods: {
    handleSelectedGroup(group) {
      if (group) {
        this.group = group;
      }
    },
    handleShowMembers(group) {
      if (this.showMembersGroup !== group) {
        this.showMembersGroup = group;
        this.$store.dispatch(
          MODULE_PREFIX_COMMUNICATION + SAVE_SHOW_MEMBERS_ON_MAP,
          {
            type: MASS_COMM_CONSTANTS.GROUP_TYPE,
            data: this.showMembersGroup,
          }
        );
      }
    },
  },
};
</script>

<style scoped></style>
